<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()" [strong]="true" class="tw-font-bold tw-text-[20px]">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="tw-text-center tw-font-bold tw-pl-0" data-cy="matrix_title">MATRIX TABLE</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="tab-menu tw-flex tw-w-full tw-overflow-x-auto">

    <div class="tab-header" (click)="selectTabMenu(tabIndicatorODDS, ODDS)" data-cy="matrix_odds_tab">
      <p class="tab-title">Odds</p>
      <div #tabIndicatorODDS class="tab-indicator"></div>
    </div>
    <div class="tab-header" (click)="selectTabMenu(tabIndicatorTOTALS, TOTALS)" data-cy="matrix_totals_tab">
      <p class="tab-title">Totals</p>
      <div #tabIndicatorTOTALS class="tab-indicator"></div>
    </div>
    <div *ngIf="poolList.includes(EX)" class="tab-header" (click)="selectTabMenu(tabIndicatorEX, EX)" data-cy="matrix_ex_tab">
      <p class="tab-title">EX</p>
      <div #tabIndicatorEX class="tab-indicator"></div>
    </div>
    <div *ngIf="poolList.includes(QU)" class="tab-header" (click)="selectTabMenu(tabIndicatorQU, QU)" data-cy="matrix_qu_tab">
      <p class="tab-title">QU</p>
      <div #tabIndicatorQU class="tab-indicator"></div>
    </div>
    <div *ngIf="poolList.includes(DBL)" class="tab-header" (click)="selectTabMenu(tabIndicatorDBL, DBL)" data-cy="matrix_dbl_tab">
      <p class="tab-title">DBL</p>
      <div #tabIndicatorDBL class="tab-indicator"></div>
    </div>
    <div class="tab-header" (click)="selectTabMenu(tabIndicatorWILL_PAYS, WILL_PAYS)" data-cy="matrix_willpays_tab">
      <p class="tab-title">WillPays</p>
      <div #tabIndicatorWILL_PAYS class="tab-indicator"></div>
    </div>
    <div class="tab-header" (click)="selectTabMenu(tabIndicatorWIN_CHART, WIN_CHART)" data-cy="matrix_win_chart_tab">
      <p class="tab-title win-chart-title tw-w-[100px]">Win Chart</p>
      <div #tabIndicatorWIN_CHART class="tab-indicator"></div>
    </div>
    <div class="tab-header" (click)="selectTabMenu(tabIndicatorWIN_TABLE, WIN_TABLE)" data-cy="matrix_win_table_tab">
      <p class="tab-title win-table-title tw-w-[100px]">Win Table</p>
      <div #tabIndicatorWIN_TABLE class="tab-indicator"></div>
    </div>
  </div>

  <div class="tab-content tw-text-sm tw-overflow-x-auto">
    <ng-container *ngIf="tab === ODDS" [ngTemplateOutlet]="oddsTemplate"></ng-container>
    <ng-container *ngIf="tab === TOTALS" [ngTemplateOutlet]="totalsTemplate"></ng-container>
    <ng-container *ngIf="tab === EX" [ngTemplateOutlet]="exTemplate"></ng-container>
    <ng-container *ngIf="tab === QU" [ngTemplateOutlet]="quTemplate"></ng-container>
    <ng-container *ngIf="tab === DBL" [ngTemplateOutlet]="dblTemplate"></ng-container>
    <ng-container *ngIf="tab === WILL_PAYS" [ngTemplateOutlet]="willPaysTemplate"></ng-container>
    <ng-container *ngIf="tab === WIN_CHART" [ngTemplateOutlet]="winChartTemplate"></ng-container>
    <ng-container *ngIf="tab === WIN_TABLE" [ngTemplateOutlet]="winTableTemplate"></ng-container>
  </div>
</ion-content>


<ng-template #oddsTemplate>
  <div *ngIf="matrix?.[TRU] || matrix?.[WIN] || matrix?.[PLC] || matrix?.[SHW]"
    class="table-odds tw-w-screen" data-cy="odds_table"
  >
    <table>
      <thead>
        <tr>
          <th></th>
          <th colspan="2" class="!tw-p-0">
            <span class="tw-font-bold tw-items-center tw-w-full tw-items-center">
              <span class="odds-th-odds tw-flex tw-justify-center tw-w-full tw-bg-[#D8E8FD]" data-cy="odds_table_header">
                ODDS
              </span>
              <span class="tru-win tw-flex tw-justify-around tw-w-full tw-text-[12px] !tw-py-[5px]">
                <span data-cy="tru_odds_table">TRU</span>
                <span data-cy="win_odds_table">WIN</span>
              </span>
          </span>
          </th>
          <th>
            <span class="odds-th" data-cy="win_table_header">
              <span>$</span>
              <span>WIN</span>
            </span>
          </th>
          <th>
            <span class="odds-th" data-cy="win_percent_table">%</span>
          </th>
          <th>
            <span class="odds-th" data-cy="plc_table_header">
              <span>$</span>
              <span>PLC</span>
            </span>
          </th>
          <th>
            <span class="odds-th" data-cy="plc_percent_table">%</span>
          </th>
          <th>
            <span class="odds-th" data-cy="shw_table_header">
              <span>$</span>
              <span>SHW</span>
            </span>
          </th>
          <th>
            <span class="odds-th" data-cy="shw_percent_table">%</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let runner of runners; index as i" [attr.data-cy]="'runner-row-' + i">
          <th>
            <span class="tw-font-bold odds-th-left" [attr.data-cy]="'runner-id-' + i">
              {{ runner?.RunnerId || '-' }}
            </span>
          </th>
          <td>
            <span [attr.data-cy]="'tru-odd-' + i">
              {{
                ((matrix?.[TRU] || null) | matrixData: i: 'odd')
              }}
            </span>
          </td>
          <td>
            <span [attr.data-cy]="'win-odd-' + i">
              {{
                ((matrix?.[WIN] || null) | matrixData: i: 'odd')
              }}
            </span>
          </td>
          <!-- WIN-->
         <td>
           <span [attr.data-cy]="'win-number-' + i">
            {{ ((matrix?.[WIN] || null) | matrixData: i) | numberWithCommas: 0 }}
          </span>
         </td>
         <td>
          <span [attr.data-cy]="'win-percent-' + i">
            {{ ((matrix?.[WIN] || null) | matrixData: i: 'percent') }}
          </span>
         </td>
          <!-- PLC -->
          <td>
            <span [attr.data-cy]="'plc-number-' + i">
              {{ ((matrix?.[PLC] || null) | matrixData: i) | numberWithCommas: 0 }}
            </span>
          </td>
         <td>
          <span [attr.data-cy]="'plc-percent-' + i">
            {{ ((matrix?.[PLC] || null) | matrixData: i: 'percent') }}
          </span>
         </td>
         <!-- SHW -->
         <td>
           <span [attr.data-cy]="'shw-number-' + i">
            {{ ((matrix?.[SHW] || null) | matrixData: i) | numberWithCommas: 0 }}
          </span>
         </td>
          <td>
            <span [attr.data-cy]="'shw-percent-' + i">
              {{ ((matrix?.[SHW] || null) | matrixData: i: 'percent') }}
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot class="tw-bg-[#D8E8FD] tw-font-bold">
        <tr>
          <td colspan="3" class="tw-text-center">
            <span data-cy="odds_totals">TOTALS</span>
          </td>
          <td>
            <span data-cy="win_totals">
              {{ (matrix?.[WIN]?.Total | numberWithCommas: 0) || '-' }}
            </span>
          </td>
          <td></td>
          <td>
            <span data-cy="plc_totals">
              {{ (matrix?.[PLC]?.Total | numberWithCommas: 0) || '-' }}
            </span>
          </td>
          <td></td>
          <td>
            <span data-cy="shw_totals">
              {{ (matrix?.[SHW]?.Total | numberWithCommas: 0) || '-' }}
            </span>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div *ngIf="!(matrix?.[TRU] || matrix?.[WIN] || matrix?.[PLC] || matrix?.[SHW])">
    <span class="tw-flex tw-p-4">
      No Odds at this Moment
    </span>
  </div>
</ng-template>


<ng-template #totalsTemplate>
  <div *ngIf="
    (singleLegDict && (singleLegDict|json) !== '{}')
    || (singleLegDict?.[WIN] && (singleLegDict?.[WIN]|json) !== '{}')
    || (singleLegDict?.[PLC] && (singleLegDict?.[PLC]|json) !== '{}')
    || (singleLegDict?.[SHW] && (singleLegDict?.[SHW]|json) !== '{}')
    || (matrix?.[WIN] && (matrix?.[WIN]|json) !== '{}')
    || (matrix?.[PLC] && (matrix?.[PLC]|json) !== '{}')
    || (matrix?.[SHW] && (matrix?.[SHW]|json) !== '{}')
    || (multiLegDict && (multiLegDict|json) !== '{}')
    || (multiRaceDict && (multiRaceDict|json) !== '{}')
  ">
    <div class="table-totals">
      <table>
        <thead>
          <tr>
            <th>Runner</th>
            <th class="totals-th">
              WIN
              {{
                '(' + (((singleLegDict?.[WIN]?.TakeoutRates || 0) * 100)  | numberWithCommas) + '%)'
              }}
            </th>
            <th class="totals-th">
              PLC
              {{
                '(' + (((singleLegDict?.[PLC]?.TakeoutRates || 0) * 100)  | numberWithCommas) + '%)'
              }}
            </th>
            <th class="totals-th">
              SHW
              {{
                '(' + (((singleLegDict?.[SHW]?.TakeoutRates || 0) * 100)  | numberWithCommas) + '%)'
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let runner of runners; index as i">
            <th>{{ runner?.RunnerId || '-' }}</th>
            <td>
              <span>
                {{ ((matrix?.[WIN] || null) | matrixData: i) | numberWithCommas: 0 }}
              </span>
            </td>
            <td>
              <span>
                {{ ((matrix?.[PLC] || null) | matrixData: i) | numberWithCommas: 0 }}
              </span>
            </td>
            <td>
             <span>
                {{ ((matrix?.[SHW] || null) | matrixData: i) | numberWithCommas: 0 }}
             </span>
            </td>
          </tr>
        </tbody>
        <tfoot class="tw-bg-[#D8E8FD]">
          <tr>
            <td class="tw-font-bold">
              <span>Totals</span>
            </td>
            <td>
              <span>
                {{ (matrix?.[WIN]?.Total | numberWithCommas: 0) || '-' }}
              </span>
            </td>
            <td>
              <span>
                {{ (matrix?.[PLC]?.Total | numberWithCommas: 0) || '-' }}
              </span>
            </td>
            <td>
              <span>
                {{ (matrix?.[SHW]?.Total | numberWithCommas: 0) || '-' }}
              </span>
            </td>
          </tr>
        </tfoot>
      </table>

      <table>
        <thead>
          <tr>
            <th colspan="2">Multi Leg</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="multiLegDict && (multiLegDict|json) !== '{}'">
            <tr *ngFor="let item of multiLegDict| keyvalue">
              <th class="totals-th">
                {{ item.key + ' (' + ((((item.value| toAny)?.TakeoutRates || 0) * 100)  | numberWithCommas) + '%)'}}
              </th>
              <td>
                <span>
                  {{ (item.value| toAny)?.Total | numberWithCommas: 0 }}
                </span>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!(multiLegDict && (multiLegDict|json) !== '{}')">
            <tr>
              <span class="tw-flex tw-p-4">
                No Multi Leg Data
              </span>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th colspan="2">Multi Race</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="multiRaceDict && (multiRaceDict|json) !== '{}'">
            <tr *ngFor="let item of multiRaceDict| keyvalue">
              <th class="totals-th">
                {{ item.key + ' (' + ((((item.value| toAny)?.TakeoutRates || 0) * 100)  | numberWithCommas) + '%)'}}
              </th>
              <td>
                <span>
                  {{ (item.value| toAny)?.Total | numberWithCommas: 0 }}
                </span>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!(multiRaceDict && (multiRaceDict|json) !== '{}')">
            <tr>
              <span class="tw-flex tw-p-4">
                No Multi Race Data
              </span>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="
    !(
      (singleLegDict && (singleLegDict|json) !== '{}')
      || (singleLegDict?.[WIN] && (singleLegDict?.[WIN]|json) !== '{}')
      || (singleLegDict?.[PLC] && (singleLegDict?.[PLC]|json) !== '{}')
      || (singleLegDict?.[SHW] && (singleLegDict?.[SHW]|json) !== '{}')
      || (matrix?.[WIN] && (matrix?.[WIN]|json) !== '{}')
      || (matrix?.[PLC] && (matrix?.[PLC]|json) !== '{}')
      || (matrix?.[SHW] && (matrix?.[SHW]|json) !== '{}')
      || (multiLegDict && (multiLegDict|json) !== '{}')
      || (multiRaceDict && (multiRaceDict|json) !== '{}')
    )
  ">
    <span class="tw-flex tw-p-4">
      No Totals Data
    </span>
  </div>
</ng-template>


<ng-template #exTemplate>
  <div *ngIf="matrix[EX]">
    <p class="tw-py-2 tw-font-bold total-top">
      PT: ${{ matrix[EX]?.Total | numberWithCommas: 0 }}
    </p>
    <div class="tw-block tw-overflow-auto">
      <table class="table-ex">
        <thead>
          <tr>
            <th class="ex-th">1/2</th>
            <th class="ex-th" *ngFor="let col of (matrix[EX]?.NumberOfColumns|convertTRange)">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of (matrix[EX]?.NumberOfRows|convertTRange); index as i">
            <th class="ex-th">{{ row }}</th>

            <ng-container *ngFor="let col of matrix[EX]?.Rows[i]?.Columns">
              <td [class]="(col?.fairValueClass||'') + ' ' + (col?.favouriteBetClass||'')" >
                <span>
                  {{
                    (!col?.data)
                      ? '&nbsp;'
                      : (col?.data | numberWithCommas: 0)
                  }}
                </span>
              </td>
            </ng-container>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!matrix[EX]">
    <span class="tw-flex tw-p-4">
      {{
        selectedRace?.Current
        && ((selectedRace?.PostTime||''|convertTimeToMinutes) < 60)
        && multiLegDict[EX]?.Total > 0
          ?  "Matrix not available at this time."
          : "Pool data is only available on the current race when minutes to post is less than 60 and wagers have been made."
      }}
    </span>
  </div>
</ng-template>


<ng-template #quTemplate>
  <div *ngIf="matrix[QU]">
    <p class="tw-py-2 tw-font-bold total-top">
      PT: ${{ matrix[QU]?.Total | numberWithCommas: 0 }}
    </p>
    <div class="tw-block tw-overflow-auto">
      <table class="table-qu">
        <thead>
          <tr>
            <th class="qu-th">1/2</th>
            <th class="qu-th" *ngFor="let col of (matrix[QU]?.NumberOfColumns|convertTRange)">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of (matrix[QU]?.NumberOfRows|convertTRange); index as i">
            <th class="qu-th">{{ row }}</th>

            <ng-container *ngFor="let col of matrix[QU]?.Rows[i]?.Columns">
              <td [class]="(col?.favouriteBetClass||'')" >
                <span>
                  {{
                    (!col?.data)
                      ? '&nbsp;'
                      : (col?.data | numberWithCommas: 0)
                  }}
                </span>
              </td>
            </ng-container>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!matrix[QU]">
    <span class="tw-flex tw-p-4">
      {{
        selectedRace?.Current
        && ((selectedRace?.PostTime||''|convertTimeToMinutes) < 60)
        && multiLegDict[QU]?.Total > 0
          ?  "Matrix not available at this time."
          : "Pool data is only available on the current race when minutes to post is less than 60 and wagers have been made."
      }}
    </span>
  </div>
</ng-template>


<ng-template #dblTemplate>
  <div *ngIf="matrix[DBL]">
    <p class="tw-py-2 tw-font-bold total-top">
      PT: ${{ matrix[DBL]?.Total | numberWithCommas: 0 }}
    </p>
    <div class="tw-block tw-overflow-auto">
      <table class="table-dbl">
        <thead>
          <tr>
            <th class="dbl-th">1/2</th>
            <th class="dbl-th" *ngFor="let col of (matrix[DBL]?.NumberOfColumns|convertTRange)">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of (matrix[DBL]?.NumberOfRows|convertTRange); index as i">
            <th class="dbl-th">{{ row }}</th>

            <ng-container *ngFor="let col of matrix[DBL]?.Rows[i]?.Columns">
              <td [class]="(col?.favouriteBetClass||'')" >
                <span>
                  {{
                    (!col?.data)
                      ? '&nbsp;'
                      : (col?.data | numberWithCommas: 0)
                  }}
                </span>
              </td>
            </ng-container>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!matrix[DBL]">
    <span class="tw-flex tw-p-4">
      {{
        selectedRace?.Current
        && ((selectedRace?.PostTime||''|convertTimeToMinutes) < 60)
        && multiLegDict[DBL]?.Total > 0
          ?  "Matrix not available at this time."
          : "Pool data is only available on the current race when minutes to post is less than 60 and wagers have been made."
      }}
    </span>
  </div>
</ng-template>


<ng-template #willPaysTemplate>
  <div *ngIf="willPays?.Pools" class="tw-block tw-overflow-auto">
    <table class="table-willpay">
      <thead>
        <tr>
          <th class="willpay-th"></th>
          <th class="willpay-th" *ngFor="let pool of willPays?.Pools">
            <div class="willpay-th-top">
              <span>
                {{
                  '$' + pool?.Wager + ' ' + pool?.PoolId
                }}
              </span>
              <span>
                {{
                  (pool?.Live | numberWithCommas: 0 )
                }}
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th class="willpay-th !tw-px-[4px]">Results</th>
          <td *ngFor="let pool of willPays?.Pools">
           <span>
              {{
                pool?.Willpays?.[0]?.Finish
              }}
           </span>
          </td>
        </tr>
        <ng-container *ngFor="let pay of willPays?.Pools?.[0]?.Willpays?.[0]?.Pays; index as i">
          <tr>
            <th class="willpay-th {{ TRACK_TYPE_lIST[selectedRace?.TrackType || 1]+'-'+pay?.RunnerId }}">
              {{ pay?.RunnerId }}
            </th>
            <td *ngFor="let pool of willPays?.Pools">
              <span>
                {{
                  pool?.Willpays?.[0]?.Pays?.[i]?.Price|| ' ' | numberWithCommas: 2
                }}
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div *ngIf="!willPays?.Pools">
    <span class="tw-flex tw-p-4">
      {{
        (selectedRace?.RaceId||0) > 1
          ? 'WillPays not available at this time'
          : 'There is no WillPay'
      }}

    </span>
  </div>
</ng-template>


<ng-template #winChartTemplate>
  <div *ngIf="(winChartOptions && (winChartOptions|json) !== '{}')">
    <div class="win-chart-content tw-flex tw-w-screen tw-overflow-x-auto">
      <div class="tw-absolute tw-left-[-5px] tw-w-screen">
        <ag-charts-angular
          class="tw-h-[60vh] tw-flex tw-w-screen"
          [options]="winChartOptions"
        ></ag-charts-angular>
      </div>
    </div>
    <div class="win-chart-buttons tw-w-full tw-absolute tw-bottom-[4px] tw-left-0 tw-w-full tw-flex tw-justify-evenly">
      <!-- (click)="openMatrix()" -->
      <!-- <ion-button (click)="winChartFilter('ALL')"  >
        ALL
      </ion-button>
      <ion-button (click)="winChartFilter('CLEAR')"  >
        CLEAR
      </ion-button> -->
      <ion-button size="small" (click)="winChartFilter('WIN')" [class.btn-active]="winChartFilterButtons.WIN">
        WIN
      </ion-button>
      <ion-button size="small" (click)="winChartFilter('TRU')" [class.btn-active]="winChartFilterButtons.TRU">
        TRU
      </ion-button>
      <ion-button size="small" (click)="winChartFilter('BOTH')" [class.btn-active]="winChartFilterButtons.BOTH">
        BOTH
      </ion-button>
    </div>
  </div>

  <div *ngIf="!(winChartOptions && (winChartOptions|json) !== '{}')">
    <span class="tw-flex tw-p-4">
      No Odds at this Moment
    </span>
  </div>
</ng-template>


<ng-template #winTableTemplate>
  <div *ngIf="(winTable && (winTable|json) !== '[]')">
    <table class="table-wintable">
      <thead>
        <tr>
          <th class="wintable-th tw-w-[25px]"></th>
          <th class="wintable-th tw-w-0" *ngFor="let item of 5|convertTRange; index as index5">
            {{
              winTable?.[index5]?.time || '-'
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let runner of runners; index as indexRunner">
          <th class="wintable-th">
            {{ runner?.RunnerId }}
          </th>
          <td *ngFor="let item of 5|convertTRange; index as index5">
            <span>
              {{
                ( (winTable?.[index5]?.totals[indexRunner]?.odds || '-')  | numberWithCommas: 2)
              }}
              <ion-icon
                *ngIf="winTable?.[index5]?.totals[indexRunner]?.odd_remark"
                name="chevron-{{winTable?.[index5]?.totals[indexRunner]?.odd_remark === 'increase' ? 'down' : 'up'}}-outline"
                [class]="winTable?.[index5]?.totals[indexRunner]?.odd_remark === 'increase' ? 'tw-text-green-500 tw-pl-[3px] tw-text-[18px]' : 'tw-text-red-500 tw-pl-[3px] tw-text-[18px]'"
              ></ion-icon>
            </span>
          </td>
      </tbody>
    </table>
  </div>

  <div *ngIf="!(winTable && (winTable|json) !== '[]')">
    <span class="tw-flex tw-p-4">
      No Odds at this Moment
    </span>
  </div>
</ng-template>

